import React, { useState } from 'react';

function AddCategoryModal({ isOpen, onClose, onAdd, parentCategory }) {
  const [name, setName] = useState('');
  const [allocation, setAllocation] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd({
      name: name.trim(),
      allocation: parseFloat(allocation)
    });
    setName('');
    setAllocation('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg">
        <h3 className="text-lg font-medium mb-4">
          {parentCategory ? `Alt Kategori Ekle - ${parentCategory}` : 'Kategori Ekle'}
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Kategori Adı</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Kategori adı girin"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Hedef Yüzde (%)</label>
              <input
                type="number"
                value={allocation}
                onChange={(e) => setAllocation(e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                min="0"
                max="100"
                step="0.1"
                placeholder="Hedef yüzde girin"
                required
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-50"
            >
              İptal
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              disabled={!name.trim() || !allocation}
            >
              Ekle
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCategoryModal;